<template>
  <div class="errorWork">
    <NavHeaderBar title="异常" rightArrow />
    <Default
      :imgurl="require('@/assets/img/df-6.png')"
      text="连接超时,请点击按钮刷新"
      :errorWork="true"
    >
      <van-button plain type="info" @click="goReload"
        >刷新一下</van-button
      ></Default
    >
  </div>
</template>

<script>
import { routerReplace } from "@/config/locationRouter";
export default {
  name: "ErrorWork",
  methods: {
    goReload() {
      routerReplace({ path: this.$route.query.fullPath });
    }
  }
};
</script>

<style lang="scss">
.errorWork {
  overflow: hidden;
}
</style>
